import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestLicenseDelete = {
    path: "/plugin-update/:slug/license/:blogId",
    method: RouteHttpVerb.DELETE
};
